export const TAB_PAGE = 'TAB_PAGE';  // tab page
export const COURSE_TYPES = 'COURSE_TYPES';  // 课程分类树
export const STORE_NOW_CATEGORY = 'STORE_NOW_CATEGORY';  // 当前查看的分类
export const CHANGE_SEARCH_VAL = 'CHANGE_SEARCH_VAL';  // 改变搜索框的值
export const IS_DOSEARCH = 'IS_DOSEARCH';
